<script lang="ts">
	import type { Provider } from '@supabase/supabase-js';

	export let provider: Provider;
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

{#if provider == 'google'}
	<svg
		class={classes}
		width="24"
		height="24"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
	>
		<path
			d="M20.78 12.209c0-.651-.058-1.278-.167-1.879h-8.65v3.557h4.943a4.235 4.235 0 0 1-1.845 2.763v2.313h2.98c1.737-1.603 2.739-3.957 2.739-6.754Z"
			fill="#4285F4"
		/>
		<path
			d="M11.964 21.184c2.48 0 4.558-.819 6.078-2.221l-2.98-2.313c-.82.551-1.863.885-3.098.885-2.388 0-4.417-1.611-5.143-3.782H3.765v2.371c1.511 2.998 4.609 5.06 8.199 5.06Z"
			fill="#34A853"
		/>
		<path
			d="M6.82 13.745A5.504 5.504 0 0 1 6.53 12c0-.61.108-1.194.292-1.745v-2.37H3.765A9.07 9.07 0 0 0 2.78 12c0 1.486.359 2.88.985 4.116l2.38-1.853.676-.518Z"
			fill="#FBBC05"
		/>
		<path
			d="M11.964 6.473c1.352 0 2.554.468 3.514 1.37l2.63-2.63c-1.594-1.487-3.665-2.397-6.144-2.397-3.59 0-6.688 2.063-8.199 5.068l3.056 2.371c.726-2.17 2.755-3.782 5.143-3.782Z"
			fill="#EA4335"
		/>
	</svg>
{:else if provider == 'discord'}
	<svg
		class={classes}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M18.942 5.297A16.29 16.29 0 0 0 14.816 4a12.09 12.09 0 0 0-.529 1.097 15.153 15.153 0 0 0-4.573 0A11.724 11.724 0 0 0 9.18 4 16.235 16.235 0 0 0 5.05 5.3C2.44 9.246 1.731 13.094 2.085 16.887a16.5 16.5 0 0 0 5.06 2.593c.41-.564.773-1.16 1.084-1.785a10.66 10.66 0 0 1-1.706-.83c.142-.106.282-.217.418-.331 3.29 1.539 6.866 1.539 10.118 0 .136.114.276.224.418.33-.544.329-1.116.607-1.71.833.314.627.675 1.224 1.084 1.785a16.461 16.461 0 0 0 5.064-2.595c.415-4.397-.71-8.21-2.973-11.59ZM8.678 14.554c-.988 0-1.798-.922-1.798-2.045 0-1.123.792-2.047 1.798-2.047 1.005 0 1.815.922 1.798 2.047.001 1.123-.793 2.045-1.798 2.045Zm6.644 0c-.988 0-1.798-.922-1.798-2.045 0-1.123.793-2.047 1.798-2.047 1.006 0 1.816.922 1.798 2.047 0 1.123-.793 2.045-1.798 2.045Z"
			fill="currentColor"
		/>
	</svg>
{:else if provider === 'apple'}
	<svg
		class={classes}
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		fill="none"
		viewBox="0 0 24 24"
		><path
			fill="currentColor"
			d="M17.611 19.2c-1.088 1.055-2.277.889-3.422.389-1.21-.511-2.322-.534-3.6 0-1.6.689-2.444.489-3.4-.39C1.767 13.612 2.567 5.1 8.723 4.79c1.5.078 2.544.822 3.422.889 1.311-.267 2.566-1.034 3.966-.934 1.678.134 2.945.8 3.778 2-3.466 2.078-2.644 6.645.534 7.922-.634 1.667-1.456 3.323-2.823 4.545l.011-.011ZM12.034 4.722C11.867 2.244 13.878.2 16.189 0c.323 2.867-2.6 5-4.155 4.722Z"
		/></svg
	>
{:else}
	No provider
{/if}
